import React, {Component} from "react";

import Backdrop from '@mui/material/Backdrop';
import CircularProgress from '@mui/material/CircularProgress';
import {Grid} from "@mui/material";

class Loading extends Component {
    constructor(props) {
        super(props);
    }

    shouldComponentUpdate(nextProps, nextState, nextContext) {
        return this.props.loading !== nextProps.loading
            || this.props.text !== nextProps.text;
    }

    render() {
        const { loading, text } = this.props;
        return (
            <div>
                <Backdrop
                    sx={{color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1}}
                    open={loading}
                >
                    <Grid container spacing={2} direction="column" alignItems="center">
                        <Grid item>
                            <span>{text}</span>
                        </Grid>
                        <Grid item>
                            <CircularProgress color="inherit"/>
                        </Grid>
                    </Grid>
                </Backdrop>
            </div>
        );
    }
}

export default Loading;
